import { useId } from "react";

export default function IncludeDemoToggle({ checked, onChange, unavailable = false }) {
  const id = useId();
  return <div className="space-y-1 text-sm max-w-full">
    <label htmlFor={id} className="flex items-center gap-2"><input id={id} type="checkbox" checked={unavailable ? true : checked} disabled={unavailable} onChange={(e) => onChange(e.target.checked)} aria-describedby={unavailable ? `${id}-reason` : undefined} data-testid="include-demo-toggle" />Inclure le contenu de démo</label>
    {unavailable && <p id={`${id}-reason`} data-testid="include-demo-unavailable" className="text-xs text-muted-foreground">Le filtrage démo/live est indisponible avec ces données ; tout le contenu reste affiché. Votre préférence est conservée pour les pages compatibles.</p>}
  </div>;
}
